import type { RefObject } from "react"

export function isNotNullRef<T>(ref: RefObject<T | null>): ref is RefObject<T> {
  return ref.current !== null
}
